// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = "LCPv1pRaN(R,i>YR@>QRe9iSec%F!3_4t6n-Q(%R(SRaKcLe:pja_7j-Q7iV9Gn!J%L,zSRSkIbdF>e+t!LEz,oVK9ea@2QR@6yXBpHVyV%-bV+So:_m8>jm:>JS>3ySQ3>!K%yaf>L,<c<<12_SbeidJ,>En,%zoeJav3<SdSieXI<+k2YSj2bcmkiRQ%%-)2%dv!Qd6I7@FSN-<pQt66n<<!Q!<6y+69Qt!>%X<2p@6p<-)!jyQaNRQpg!F6<4$27y@G<-6p<dQI%!:aQ!)27@QI%4v>jzvaj@F2iX<pbR)2<4$p_@:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll";
